import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { dateFormatter } from 'utils/grid';
import { GridColDef } from '@mui/x-data-grid-pro';
import {
  ExpenseClaimRouteResponse,
  TransportationTypeResponse
} from 'generated/index';

const useColumnDefinitions = () => {
  const { t } = useTranslation('common');

  return useMemo(
    () =>
      [
        {
          field: 'employeeName',
          type: 'string',
          headerName: t('employee'),
          valueGetter: (params) => params.row?.employment?.employeeName ?? '',
          minWidth: 200
        },
        {
          field: 'date',
          type: 'date',
          headerName: t('date'),
          valueFormatter: dateFormatter,
          width: 120
        },
        {
          field: 'routes',
          type: 'string',
          headerName: t('travelExpenseClaims.travelDistance'),
          valueFormatter: (params) => {
            const routes = (params.value || []) as ExpenseClaimRouteResponse[];
            const distanceInMeters = routes.reduce(
              (acc, route) => acc + route.distanceInMeters,
              0
            );
            const distanceInKm = distanceInMeters / 1000;
            return distanceInKm % 1 === 0
              ? distanceInKm
              : distanceInKm.toFixed(2).replace('.', ',');
          },
          width: 120
        },
        {
          field: 'transportationTypeName',
          type: 'string',
          headerName: t('transportationType'),
          valueFormatter: (params) => {
            const transportationType =
              params.value as TransportationTypeResponse;
            return transportationType ? transportationType.name : '';
          },
          minWidth: 150
        },
        {
          field: 'description',
          type: 'string',
          headerName: t('description'),
          flex: 1,
          minWidth: 200
        },
        {
          field: 'statusNote',
          type: 'string',
          headerName: t('travelExpenseClaims.statusNote'),
          flex: 1,
          minWidth: 200
        },
        {
          field: 'status',
          type: 'string',
          headerName: t('status'),
          valueFormatter: (params) =>
            params.value ? t(`travelExpenseClaims.status.${params.value}`) : '',
          minWidth: 150
        }
      ] as GridColDef[],
    [t]
  );
};

export default useColumnDefinitions;
